import { render, staticRenderFns } from "./CompleteConversationReservation.vue?vue&type=template&id=59afde5b&scoped=true&"
import script from "./CompleteConversationReservation.vue?vue&type=script&lang=js&"
export * from "./CompleteConversationReservation.vue?vue&type=script&lang=js&"
import style0 from "./CompleteConversationReservation.vue?vue&type=style&index=0&id=59afde5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59afde5b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VMain})
